import React from 'react'
import { useDocumentsConfig } from '../contexts/DocumentsConfigContext'
import PrepareHelloSignModal from './PrepareHelloSignModal'
import PrepareDocuSignModal from './PrepareDocuSignModal'

const PrepareEsignModal = (props) => {
  const { enableDocusign } = useDocumentsConfig()

  return enableDocusign ? (
    <PrepareDocuSignModal {...props} />
  ) : (
    <PrepareHelloSignModal {...props} />
  )
}

export default PrepareEsignModal
